// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1F4Nm","inputDescription":"styles_inputDescription__Br9hI"};